import { useEffect } from "react";
import { onAuthStateChanged } from "../helpers/auth";

export const FirebaseProvider: React.FunctionComponent = ({ children }) => {
  useEffect(() => {
    onAuthStateChanged();
  }, []);
  return <>{children}</>;
};
